import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { AppState, EL_PATRON_SHOW_IFRAME, HTTP_STATUS_CODE } from 'src/app';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private alreadyFlagged: boolean;
  private unauthorizedErrorCounter: number;

  constructor(private store: Store<AppState>) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error) => {
        if (request.responseType !== 'text') {
          this.alreadyFlagged = true;
        }
        this.handleError(error, request.url);
        return throwError(error);
      }),
      tap(() => {
        request.responseType !== 'text' &&
          this.restartUnauthorizedHandlerCounter();
      }),
      catchError((error: any) => {
        if (!this.alreadyFlagged) {
          this.handleError(error, request.url);
          this.alreadyFlagged = true;
        }

        return throwError(this.unwrapHttpError(error));
      }),
    );
  }

  private restartUnauthorizedHandlerCounter() {
    this.unauthorizedErrorCounter = 0;
  }

  private handleError(error: any, url: string) {
    if (
      [
        HTTP_STATUS_CODE.UNAUTHORIZED,
        HTTP_STATUS_CODE.FORBIDDEN,
        HTTP_STATUS_CODE.FAILED_OR_CANCELED,
      ].includes(error.status)
    ) {
      const blacklistedUrls = [
        'GetL2MarketData',
        'CancelOrder',
        'GetCommodityValuesByRange',
        'RegisterWithdrawal',
        'security-settings',
        'v1/token',
      ];
      const hasInvalidUrl = blacklistedUrls.filter((searchString) => {
        return url.indexOf(searchString) !== -1;
      });
      if (!hasInvalidUrl.length) {
        this.updateCounter();
        if (this.unauthorizedErrorCounter >= 3) {
          this.store.dispatch({
            type: EL_PATRON_SHOW_IFRAME,
            payload: true,
          });
        }

        console.warn('401 - 403 - 0');
      }
    }
  }

  private updateCounter() {
    this.unauthorizedErrorCounter++;
    console.warn('retry:' + this.unauthorizedErrorCounter);
  }

  private unwrapHttpError(error: any): any {
    try {
      let jsonError: any;

      if (error.error) {
        jsonError = error.error;
      } else if (error instanceof SyntaxError) {
        jsonError = {
          message: error.stack,
        };
      } else {
        const extraMessage = error.toString
          ? error.toString()
          : error.status !== undefined
          ? `Status: ${error.status} - Url: ${error.url}`
          : '';
        jsonError = {
          code: error.status !== undefined ? error.status : -1,
          message: `An unexpected error occurred. ${extraMessage}`,
        };
      }

      /**
       * This _status variable will replace code variable eventually.
       * This addition will help with endpoint logging errors to NR.
       */
      const _status = error.status !== undefined ? error.status : -1;
      const _url = (error.url || '').replace(/\//g, '|');

      /**
       * NOTE: Don't use destructuring to avoid overwriting
       * class definition.
       */
      jsonError._status = _status;
      jsonError._url = _url;
      return jsonError;
    } catch (jsonError) {
      return {
        code: -1,
        message: 'An unexpected error occurred.',
      };
    }
  }
}
